export enum EmployeeCourseState {
    unknown = 0,
    noAnyTopicOpen = 1,
    inProgress = 2,
    quizCompleted = 3,
    allTopicsPassed = 4
}